import React from 'react';
import { FaStore, FaUsers, FaGem } from 'react-icons/fa';

const About = () => {
  return (
    <div className="py-16 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">About <span className="text-orange-500">BRframes</span></h1>
          <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <div className="flex items-center gap-4 mb-6">
            <FaStore className="text-5xl text-orange-500" />
            <h2 className="text-2xl font-semibold text-gray-800">Our Story</h2>
          </div>
          <p className="text-gray-600 leading-relaxed">
            BRframes is a premium eyewear frames manufacturer and supplier dedicated to providing high-quality, stylish, and comfortable frames. With years of experience in the industry, we blend craftsmanship with modern design to create eyewear that enhances your vision and style.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl shadow-xl p-6">
            <FaUsers className="text-4xl text-orange-500 mb-4" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Our Mission</h3>
            <p className="text-gray-600">To make premium eyewear accessible to everyone while maintaining the highest standards of quality and design.</p>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6">
            <FaGem className="text-4xl text-orange-500 mb-4" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Our Vision</h3>
            <p className="text-gray-600">To be the most trusted eyewear brand globally, known for innovation, durability, and style.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;